import React, { useEffect, useState } from "react";
import "../siteSettings/siteSettings.css";
import DropzoneThumbnail from "../../components/dropzone/DropzoneThumbnail";
import { toast } from "react-toastify";

const SiteSettings = () => {
  const [primaryColor, setPrimaryColor] = useState("#81B14F");
  const [secondaryColor, setSecondaryColor] = useState("#FF5733");
  const [logoImage, setLogoImage] = useState(null);
  const [siteSetting, setSiteSettings] = useState({});
  const [siteUnderMaintenance, setSiteUnderMaintenance] = useState(false); // Initialize as false

  const handlePrimaryColor = (event) => {
    setPrimaryColor(event.target.value);
  };

  const handleSecondaryColor = (event) => {
    setSecondaryColor(event.target.value);
  };

  const handleImageUpload = (imageUrl) => {
    setLogoImage(imageUrl); // Update the logo image URL
  };

  const saveSiteSetting = async () => {
    const data = {
      primaryColor: primaryColor,
      secondaryColor: secondaryColor,
      logo: logoImage,
      siteUnderMaintenance: siteUnderMaintenance, // Pass the correct boolean value
    };

    try {
      const response = null;
      if (response) {
        toast.success("Changes saved");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSiteSetting = async () => {
    try {
      const response = null;
      if (response) {
        setSiteSettings(response);
        setPrimaryColor(response.primaryColor || "#81B14F");
        setSecondaryColor(response.secondaryColor || "#FF5733");
        setLogoImage(response.logo);
        setSiteUnderMaintenance(response.siteUnderMaintenance); // Set the correct initial value
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSiteSetting();
  }, []);

  return (
    <div className="container" style={{ width: "520px" }}>
      <div className="overview">
        <div className="title">
          <ion-icon name="settings-outline"></ion-icon>
          <span className="text">Site Settings</span>
        </div>
      </div>

      <div className="mt-5">
        <h6>Colors Of The Website</h6>

        <div className="mt-3 themeColor">
          <div>
            <label>Primary Color:</label>
            <input
              type="color"
              value={primaryColor}
              onChange={handlePrimaryColor}
              colorpick-eyedropper-active="false"
            />
          </div>
          {/* <div>
            <label>Secondary Color:</label>
            <input
              type="color"
              value={secondaryColor}
              onChange={handleSecondaryColor}
              colorpick-eyedropper-active="false"
            />
          </div> */}
        </div>
      </div>

      <div className="mt-3">
        <h6 className="col-form-label">Logo</h6>

        <DropzoneThumbnail title="Logo" onImageUpload={handleImageUpload} />
      </div>

      <div className="mt-3 d-flex">
        <h6 className="col-form-label">Site under maintenance</h6>
        <label className="switch mt-2 ms-auto">
          <input
            type="checkbox"
            checked={siteUnderMaintenance} // Sync with the state
            onChange={() => setSiteUnderMaintenance(!siteUnderMaintenance)} // Toggle the state correctly
          />
          <span className="slider round"></span>
        </label>
      </div>

      <button
        id="site-setting"
        className="btn-model mt-5"
        onClick={saveSiteSetting}
        type="submit"
      >
        Save Changes
      </button>
    </div>
  );
};

export default SiteSettings;
